<div class="loading-container">
    <div class="logo-wrapper">
        <img src="assets/img/golftech-v2.png" alt="Logo" class="loading-logo"/>
        <mat-progress-bar
           
            mode="indeterminate"
            class="loading-progress-bar">
        </mat-progress-bar>
    </div>
</div>